// -- Shared channel between StartAssessment (the page being left) and the
// App-level AssessmentLeaveGuard (which stays mounted while the router swaps
// /start-assessment out). localStorage is the vehicle so neither component
// imports the other, and the values survive the page swap in between.

const ARMED = "cpa_assessment_armed";        // "1" while a draft is in progress
const DEST = "cpa_leave_pending_dest";       // where the therapist was heading
const ANCHOR = "cpa_leave_pending_anchor";   // the /start-assessment URL to bounce back to

const read = (key) => { try { return localStorage.getItem(key); } catch { return null; } };
const write = (key, value) => { try { localStorage.setItem(key, value); } catch { /* private mode - best effort */ } };
const remove = (key) => { try { localStorage.removeItem(key); } catch { /* best effort */ } };

export const isAssessmentArmed = () => read(ARMED) === "1";

export const setAssessmentArmed = (armed) => write(ARMED, armed ? "1" : "0");

export const stashPendingLeave = (dest, anchor) => { write(DEST, dest); write(ANCHOR, anchor); };

export const takePendingLeave = () => {
  const dest = read(DEST);
  const anchor = read(ANCHOR);
  remove(DEST);
  remove(ANCHOR);
  return { dest, anchor };
};